<template>
  <ReportSection
    :columns="3"
    data-test-id="ValueReport__securityCard"
    title="Security &amp; Compliance"
  >
    <Stat
      v-for="(data, index) in metrics"
      :key="`security-stat-${index}`"
      :metric="data"
    />
  </ReportSection>
</template>

<script>
import ReportSection from './ReportSection.vue';
import Stat from './Stat.vue';

export default {
  name: 'SecurityCard',

  components: {
    ReportSection,
    Stat,
  },

  props: {
    metrics: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
